import { Location } from "@angular/common";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { SITE_ROUTES } from "shared/enums/routes.enum";

@Injectable({
    providedIn: 'root'
})

export class RouterService {
    constructor(
        private router: Router,
        private location: Location
    ) { }

    navigate(path: string, queryParams: Record<string, string | number> = {}, shouldReplace: boolean = false) {
        const navigationOptions: Record<string, any> = { queryParams };
        if (shouldReplace) navigationOptions['replaceUrl'] = path;
        this.router.navigate([path], navigationOptions);
    }

    goToLogin() {
        this.navigate(SITE_ROUTES.LOGIN, {}, true);
    }

    parseUrl(path: string) {
        return this.router.parseUrl(path);
    }

    navigateBack() {
        this.location.back();
    }

    isRouteActive(route: SITE_ROUTES): boolean {
        return route === window.location.pathname;
    }
}